module.exports = __webpack_public_path__ + "static/media/vrida.d95ce5de.mp3";